module.exports = __webpack_public_path__ + "static/media/contemporain.1ab03858.jpg";